import { createAsyncThunk } from '@reduxjs/toolkit';
import { AddManifestazioneToPreferitiPayload } from './sportNavAccordion/components/sportNavAccordionContent/SportNavAccordionContent';
import { sportApi } from 'features/api/sportApiSlice';
import { updatePreferitiManifestazione as updatePreferitiManifestazioneAction } from 'features/sport/sportSlice';

type UpdatePreferitiManifestazioneProps = {
  method: 'add' | 'delete';
} & AddManifestazioneToPreferitiPayload;

export const updatePreferitiManifestazione = createAsyncThunk(
  'updatePreferitiManifestazione',
  async ({ method, ...props }: UpdatePreferitiManifestazioneProps, { dispatch }) => {
    await dispatch(sportApi.endpoints.addManifestazioneToPreferiti.initiate(props));
    dispatch(updatePreferitiManifestazioneAction({ method, id: props.id }));
  }
);
